export const CALCULATOR_KEYS = {
	one: '1',
	two: '2',
	three: '3',
	four: '4',
	five: '5',
	six: '6',
	seven: '7',
	eight: '8',
	nine: '9',
	zero: '0',
	delete: 'delete',
	dot: '.',
	min: 'min',
	max: 'max',
} as const satisfies Record<string, string>;

export type CalculatorKey = (typeof CALCULATOR_KEYS)[keyof typeof CALCULATOR_KEYS];

export const CALCULATOR_KEYBOARDS = [
	CALCULATOR_KEYS.one,
	CALCULATOR_KEYS.two,
	CALCULATOR_KEYS.three,
	CALCULATOR_KEYS.delete,
	CALCULATOR_KEYS.four,
	CALCULATOR_KEYS.five,
	CALCULATOR_KEYS.six,
	CALCULATOR_KEYS.dot,
	CALCULATOR_KEYS.seven,
	CALCULATOR_KEYS.eight,
	CALCULATOR_KEYS.nine,
	CALCULATOR_KEYS.zero,
] as const satisfies CalculatorKey[];
